export enum Types {
	CADASTRAR_PARAMETRO_LOCALIDADE = '@SGU/CADASTRAR_PARAMETRO_LOCALIDADE',
	CADASTRAR_PARAMETRO_LOCALIDADE_SUCCESS = '@SGU/CADASTRAR_PARAMETRO_LOCALIDADE_SUCCESS',
	CADASTRAR_PARAMETRO_LOCALIDADE_FAILURE = '@SGU/CADASTRAR_PARAMETRO_LOCALIDADE_FAILURE',
	CADASTRAR_PARAMETRO_LOCALIDADE_CLEAR = '@SGU/CADASTRAR_PARAMETRO_LOCALIDADE_CLEAR',
}

export interface CadastrarParametroLocalidade {
	status: number;
	data: null | ParametroLocalidadeData;
}

interface ParametroLocalidadeData {
	status: string;
	statusMensagem: string;
}

export interface CadastrarParametroLocalidadeRequest {
	id?: number | string;
	descricao: string;
	sigla: string;
	valor: string;
	idLocalidade: string | number[] | number;
}
